import {
  Link,
  useLoaderData,
  useParams
} from "react-router-dom";
import * as API from "../services/vismedicas";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getVismedicasByID(params.vismedicasId);
}

export function VismedicasItem(props) {
  const vismedicas = useLoaderData();
  const errorMessage = vismedicas.message;

  console.log(vismedicas);

  const vismedResp = vismedicas.meta?.vismedResp;
  const vismedFecha = vismedicas.meta?.metaFecha;
  const vismedHora = vismedicas.meta?.vismedHora;
  const vismedObs = vismedicas.meta?.vismedObs;

  const vismedDate = new Date(vismedicas.date);
  const diffDate = Math.abs(new Date() - vismedDate) / 36e5;

  let { tratamientoId } = useParams();

  return (
    <>
      <div id='content'>
        {vismedicas.length === 0 ? (
          <div>Cargando...</div>
        ) : (
        errorMessage? (
          <p>{errorMessage}</p>
        ) : (
          <form id='formUpdatelement'>
            <fieldset id='disabledContainer' disabled='disabled'>
              <div className='grid--2col'>
                <div className='field'>
                  <label htmlFor='vismedResp'>Responsable</label>
                  <div className='control'>
                    <input
                      readOnly
                      className='input'
                      id='vismedResp'
                      required
                      type='text'
                      value={vismedResp}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='vismedFecha'>Fecha visita</label>
                  <div className='control'>
                    <input
                      readOnly
                      className='input'
                      id='vismedFecha'
                      required
                      type='date'
                      value={vismedFecha}
                    />
                  </div>
                </div>
                {/* <div className='field'>
                  <label htmlFor='vismedHora'>Hora de Visita</label>
                  <div className='control'>
                    <input
                      readOnly
                      className='input'
                      id='vismedHora'
                      required
                      type='time'
                      value={vismedHora}
                    />
                  </div>
                </div> */}
              </div>
              <div className='field'>
                <label htmlFor='vismedObs'>Observaciones</label>
                <div className='control'>
                  <textarea
                    readOnly
                    className='textarea'
                    name='vismedObs'
                    id='vismedObs'
                    value={vismedObs}
                  ></textarea>
                </div>
              </div>
            </fieldset>
          </form>
        ))}
      </div>
      {!errorMessage &&
      <div id='actions'>
      {((diffDate <= 72 && props.userRole.includes('medicina')) || props.userRole.includes('administrador')) && (
        <Link className='button is-link' to={`edit`}>
          Editar
        </Link>
      )}
      {(props.userRole.includes('administrador') || props.userRole.includes('medicina')) && (
        <Link className="button is-link" to={`../${tratamientoId}/hospitalizacion/visitas-medicas/new`}>Nuevo</Link>
      )}
      </div>
      }
    </>
  );
}
